import * as Yup from "yup";
import { campo_obligatorio, email_invalido } from "../../utils/traductor";

export function initialValues(state) {
  return {
    email: state.email,
  };
}

export function validationSchema() {
  return Yup.object({
    email: Yup.string()
      .email(` ${email_invalido} `)
      .required(` ${campo_obligatorio} `),
  });
}
